import * as React from 'react';
import moment from 'moment';
import { IFilmOrderListItem } from '../Entities';
import * as Site from '../../../shared/Site';
import { Link } from 'react-router-dom';
import ProductPropertiesIcons from '../../propertyIcons/ProductPropertiesIcons';
import OrderListTableCell from '../../../components/common/OrderListTableCell';
import * as Features from '../../../shared/Features';
import { Translate } from '../../../shared/LanguageService';

interface FilmOrderListRowProps {
    key: number;
    order: IFilmOrderListItem;
    user: any;
}

const FilmOrderListRow = (props: FilmOrderListRowProps) => {
    const canViewOrder = Features.hasFeature(Features.ViewOrder, props.user);
    const orderLink = `/orders/${props.order.orderId}`;

    let rowClass = Site.getOrderCssClass(props.order.site);
    if (props.order.isExpress) {
        rowClass += ' express';
    } else if (props.order.isExpressWeekend) {
        rowClass += ' express-weekend';
    } else if (props.order.isEarlyDelivery) {
        rowClass += ' early-delivery';
    }

    return (
        <tr className={rowClass}>
            <td>
                <Link to={`/ordercollections/${props.order.orderCollectionId}`}>
                    {props.order.orderNumber}
                </Link>
            </td>
            <OrderListTableCell clickable={canViewOrder} navigateTo={orderLink}>
                {props.order.brokerFirmName}
            </OrderListTableCell>
            <OrderListTableCell clickable={canViewOrder} navigateTo={orderLink}>
                {props.order.productName}
            </OrderListTableCell>
            <OrderListTableCell clickable={canViewOrder} navigateTo={orderLink}>
                {props.order.address}
            </OrderListTableCell>
            <OrderListTableCell clickable={canViewOrder} navigateTo={orderLink}>
                {props.order.city}
            </OrderListTableCell>
            <OrderListTableCell clickable={canViewOrder} navigateTo={orderLink}>
                {' '}
                {props.order.photographerName}{' '}
            </OrderListTableCell>
            <OrderListTableCell clickable={canViewOrder} navigateTo={orderLink}>
                {' '}
                {props.order.deadline && moment(props.order.deadline).format('L LT')}{' '}
            </OrderListTableCell>
            <OrderListTableCell clickable={canViewOrder} navigateTo={orderLink}>
                {' '}
                {Translate(props.order.filmStatus.displayName)}{' '}
            </OrderListTableCell>
            <OrderListTableCell clickable={canViewOrder} navigateTo={orderLink}>
                {props.order.assignedUserName}
            </OrderListTableCell>
            <OrderListTableCell clickable={canViewOrder} navigateTo={orderLink}>
                <ProductPropertiesIcons
                    properties={props.order.productProperties}
                ></ProductPropertiesIcons>
            </OrderListTableCell>
        </tr>
    );
};

export default FilmOrderListRow;
